/*  ========================================================================
    # Scripts - Tabs
    ========================================================================  */

const Tabs = {
  cfg: {
    tabEntries: document.querySelectorAll('.s-tabs__tab'),
    tabContentEntries: document.querySelectorAll('.s-tabs__content-item'),
    states: {
      tabActive: 's-tabs__tab--active',
      contentActive: 's-tabs__content-item--active'
    }
  },

  /**
   * Handler.
   */
  handler() {
    this.cfg.tabEntries.forEach(entry => {
      entry.addEventListener('click', () => {
        const tabTarget = entry.getAttribute('data-tab-target');
        entry.classList.add(this.cfg.states.tabActive);
        entry.setAttribute('aria-selected', 'true');

        this.cfg.tabContentEntries.forEach(contentEntry => {
          if (contentEntry.getAttribute('data-tab') === tabTarget) {
            contentEntry.classList.add(this.cfg.states.contentActive);
          } else {
            contentEntry.classList.remove(this.cfg.states.contentActive);
          }
        });

        this.cfg.tabEntries.forEach(tabEntry => {
          if (tabEntry.getAttribute('data-tab-target') !== tabTarget) {
            tabEntry.classList.remove(this.cfg.states.tabActive);
            tabEntry.setAttribute('aria-selected', 'false');
          }
        });
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.tabEntries.length > 0) this.handler();
  }
};

export default Tabs;
